<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <span v-on="{ ...tooltip }">
          <v-btn class="mr-1" small color="primary" :disabled="disabled" v-on:click="openDialog" icon>
            <v-icon>mdi-file-move-outline</v-icon>
          </v-btn>
        </span>
      </template>
      <span>{{ $t("reports.PrintReportCards") }}</span>
    </v-tooltip>

    <v-dialog v-model="dialog" max-width="400" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("reports.PrintReportCards") }}</span>
        </v-card-title>
        <v-card-text>

          <div v-if="loading" class="mt-4">
            <v-progress-linear indeterminate color="blue" height="20"></v-progress-linear>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="closeDialog" :disabled="loading">
            {{ $t("Cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onOk" :disabled="loading">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      reportInfo: {
        pageCount: '1',
      },
      regexPageCount: /^[1-9][0-9]*$/,
      pagesCountRules: [
        (v) => !!v || this.$t('reports.pageCountIsRequired'),
        (v) =>
          v.match(this.regexPageCount) !== null ||
          this.$t('reports.unacceptableSymb'),
      ],
      loading: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.loading = false;
    },
    async onOk() {
      if (this.isGood()) {
        this.loading = true;
        try {
          await this.$emit('createReport', this.reportInfo);
          setTimeout(() => {
            this.loading = false;
            this.dialog = false;
          }, 2000);
        } catch (error) {
          console.error('Error creating report:', error);
          this.loading = false;
        }
      }
    },
    isGood() {
      return this.pagesCountRules.every((rule) => rule(this.reportInfo.pageCount));
    },
  },
};
</script>
